import React, { Component } from 'react';
import { Button, Col, Container, Row } from 'reactstrap';
import { Redirect } from 'react-router-dom';

import { LogoHeader } from '../../../containers/Components/index'

import instagram_square from '../../../assets/img/instagram-square.png';


class Architecture extends Component {
  constructor(props) {
    super(props);
    this.state = {
      login: false,
      signup: false,
      warning: "",
      showVerify: false,
      html_btn_status: 0,
    };
    this.user_name = "";
    this.pwd = "";
  }

  renderRedirect = () => {
    if (this.state.login) {
      return <Redirect to= { '/login/'} />
    }
    if (this.state.signup) {
      return <Redirect to= { '/register/'} />
    }
  }
  render() {

    // let slider_count = 4;
    // if (window.innerWidth < 520) {
    //   slider_count = 4;
    // }

    return (
      <div className="app flex-row font-Poppins">
      {this.renderRedirect()}
        <React.Fragment>
        <LogoHeader />
        
        <div className="app-body p-0 m-0 width-100vw mt-5 ">
            <Container className = "background-white" fluid>
               <Row className = "about_page_gradient mt-3 ">
                 <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                 </Col>
                 <Col xs="6" sm="6" lg="2">
                  <h5 className = "m-3 text-white"> Architecture </h5>
                 </Col>
                </Row>
                <Row>
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                  </Col>
                  <Col xs="12" sm="12" lg="8">
                    <h6 className = "mt-5 pt-2 line-height-h">
                     Right from design mockups to walk-through, VR allows the architect to project 
                     his Building Information Module to the real estate developers in the most 
                     effective manner. Even if we look beyond marketing the project well, an 
                     architect can get a lot of assistance from Virtual Reality. He can get valuable 
                     feedback on the look, functionality, and overall experience. This can be integrated 
                     into the final design deliverable for demonstrating a superior quality workmanship.                    
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                      Additionally, showcasing the design rendering and 3D models to 
                      multiple decision-makers becomes an efficient process. VR assists 
                      the architect to communicate an idea with impressive visual aid 
                      with the decision makers.
                      <br></br>
                      Virtual reality and augmented reality are quickly expanding into the AEC world.
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                      The conversation might seem a little bit like old news. AR/VR technology 
                      has been around for some time and has been a clear favorite of the media 
                      for most of it. But for any who have paid closer attention to the conversation, 
                      the stakes for the AEC industry have changed pretty dramatically since the 
                      technology was brand new.
                      <br></br> 
                      While major technology breakthroughs (often hardware) are covered by the media, 
                      we don’t always hear about the incremental shifts and improvements that are regularly 
                      taking place, especially in the software realm.
                      What’s more, most would agree that the AEC industry is at least a year or 
                      two (if not more) behind the entertainment industry in finding meaningful ways to 
                      leverage AR/VR technology for the greatest impact. Part of the difficulty is the 
                      continuous innovation that keeps improving these tools often discourages early 
                      adoption by budget-limited firms.
                      <br></br>
                      That being said, if you take a look at AR/VR tools for the AEC industry today, 
                      it would seem that we are turning a corner for widespread viability and adoption. 
                      Both software and hardware tools for AR/VR are better performing, cheaper, and more 
                      accessible than ever, and if you lost interest in the initial wave of popularity, it 
                      may be worth your while to check back in on where AR/VR is in the AEC industry today. 
                      You might just be surprised.
                    </h6>
                  </Col>  
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                  </Col>
                </Row>
              {/* -------------- Footer Start -------- */}
                <Row className="mt-5">
                </Row>
                <Row className="pt-5 pb-5 home-background-gray">
                  <Col xs="0" sm="0" lg="1">
                  </Col>
                  <Col xs="4" sm="4" lg="2">
                    <Row className = "ml-2 text-left">
                      <Col className="mt-5 mb-4" md = '12'> 
                        <div>PRODUCT</div>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                         <a href = "/feature"><div className = "font-size-10" >Features</div></a>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "/appguide"><div className = "font-size-10" >App Guide</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary"  md = '12'> 
                        <div className = "font-size-10" >Platform Guide</div>
                      </Col>
                      <Col className = "mb-2 text-secondary"  md = '12'> 
                        <a href = "/customdev"><div className = "font-size-10" >Custom Development</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary"  md = '12'> 
                        <div className = "font-size-10" >Pricing</div>
                      </Col>
                      <Col className = "mb-2 text-secondary"  md = '12'> 
                        <a href = "https://goo.gl/1s6PZH" target="_blank" rel="noopener noreferrer">
                        <div className = "font-size-10" >Get VR Headset</div></a>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs="4" sm="4" lg="2">
                    <Row className = "text-left ml-2">
                      <Col className="mt-5 mb-4" md = '12'> 
                        <div >USE CASES</div>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "/realestate"><div className = "font-size-10" >Real Estate</div></a>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "/architecture"><div className = "font-size-10" >Architecture</div></a>
                      </Col>
                      <Col className = "mb-2  text-secondary" md = '12'> 
                        <a href = "/medical"><div className = "font-size-10" >Medical</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/retail"><div className = "font-size-10" >Retail</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/sports"><div className = "font-size-10" >Sports</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/media"><div className = "font-size-10" >Media</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/travel"><div className = "font-size-10" >Travel</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/education"><div className = "font-size-10" >Education</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/training"><div className = "font-size-10" >Training</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/ecommerce"><div className = "font-size-10" >Ecommerce</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/entertainment"><div className = "font-size-10" >Entertainment</div></a>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs="4" sm="4" lg="2">
                    <Row className = "text-left ml-2">
                      <Col className="mt-5 mb-4" md = '12'> 
                        <div>Support</div>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "http://www.icomputinglabs.in/blog/" target="_blank" rel="noopener noreferrer">
                        <div className = "font-size-10" >Blog</div> </a>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "/faq"><div className = "font-size-10" >FAQ</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/contact"><div className = "font-size-10" >Contact</div></a>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs="6" sm="6" lg="2">
                    <Row className = "text-left ml-2">
                      <Col className="mt-5 mb-4" md = '12'> 
                        <div>COMPANY</div>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "/about"><div className = "font-size-10" >About</div></a>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "/privacy"><div className = "font-size-10" >Privacy Policy</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/tos"><div className = "font-size-10" >Terms of Service</div></a>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs="6" sm="6" lg="2">
                    <Row className = "text-left ml-2">
                      <Col className="mt-5 mb-4" md = '12'> 
                        <div>GET CONNECTED</div>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "https://www.facebook.com/icomputinglabs/" target="_blank" rel="noopener noreferrer">
                        <div className = "font-size-10" ><i className = "text-primary fa fa-facebook-square fa-lg mr-2" />facebook</div>
                        </a>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "https://www.instagram.com/icomputinglabs/" target="_blank" rel="noopener noreferrer">
                        <div className = "font-size-10" ><img  alt="" src={instagram_square} className = "text-primary width-16 mr-2" />instagram</div>
                        </a>
                      </Col>
                      <Col className = "mb-2 text-secondary"  md = '12'> 
                        <a href = "https://twitter.com/iComputingLabs" target="_blank" rel="noopener noreferrer">
                        <div className = "font-size-10" ><i className = "text-primary fa fa-twitter-square fa-lg mr-2" />twitter</div>
                        </a>
                      </Col>
                      <Col className = "mb-2 text-secondary"  md = '12'>
                        <a href = "https://www.linkedin.com/company/13404850/" target="_blank" rel="noopener noreferrer">
                        <div className = "font-size-10" ><i className = "text-primary fa fa-linkedin-square fa-lg mr-2" />linkedin</div>
                        </a>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              {/* -------------- Footer End -------- */}
  
            </Container>
        </div>
        </React.Fragment>
      </div>
    );
  }
}

export default Architecture;



// WEBPACK FOOTER //
// ./src/views/Pages/Architecture/Architecture.js